import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-informations-client-read-mode',
  templateUrl: './informations-client-read-mode.component.html',
  styleUrls: ['./informations-client-read-mode.component.scss'],
})
export class InformationsClientReadModeComponent {
  @Input() informationsClient!: Report.Customer;
}
